// App.tsx
import { Routes, Route } from 'react-router-dom';
import Layout from '@/components/Layout';
import SimpleDashboard from '@/components/Dashboard/SimpleDashboard';
import SystemPage from '@/components/System/SystemPage';
import AgentsPage from '@/components/Agents/AgentsPage';
import AgentDetails from '@/components/Agents/AgentDetails';
import LearningCenter from '@/components/Learning/LearningCenter';
import DirectAgentTester from '@/components/Agents/DirectAgentTester';
import WorkflowsPage from '@/components/Workflows/WorkflowsPage';
import WorkflowDetails from '@/components/Workflows/WorkflowDetails';
import AdminPage from '@/components/Admin/AdminPage';
import NotFound from '@/components/NotFound';
import { TicketAnalysisPage } from '@/components/ServiceNow/TicketAnalysisPage';
import { RefreshProvider } from '@/contexts/RefreshContext';
import { DataCacheProvider } from '@/contexts/DataCacheContext';
import { AuthProvider, useAuth } from '@/contexts/AuthContext';
import LoginPage from '@/components/LoginPage';

function ProtectedApp() {
  const { isAuthenticated } = useAuth();

  if (!isAuthenticated) {
    return <LoginPage />;
  }

  return (
    <DataCacheProvider>
      <RefreshProvider>
        <Layout>
          <Routes>
            {/* Dashboard */}
            <Route path="/" element={<SimpleDashboard />} />

            {/* System Pages - Shows orders + audit trail for each system */}
            <Route path="/system/:systemId" element={<SystemPage />} />

            {/* Agents */}
            <Route path="/agents" element={<AgentsPage />} />
            <Route path="/agents/:agentType" element={<AgentDetails />} />

            {/* Learning Center */}
            <Route path="/learning" element={<LearningCenter />} />

            {/* Direct Agent Tester */}
            <Route path="/direct-test" element={<DirectAgentTester />} />

            {/* Workflows */}
            <Route path="/workflows" element={<WorkflowsPage />} />
            <Route path="/workflows/:workflowId" element={<WorkflowDetails />} />

            {/* ServiceNow Ticket Analysis */}
            <Route path="/ticket-analysis" element={<TicketAnalysisPage />} />

            {/* Admin */}
            <Route path="/admin" element={<AdminPage />} />

            {/* 404 */}
            <Route path="*" element={<NotFound />} />
          </Routes>
        </Layout>
      </RefreshProvider>
    </DataCacheProvider>
  );
}

function App() {
  return (
    <AuthProvider>
      <ProtectedApp />
    </AuthProvider>
  );
}

export default App;
